module.exports = __webpack_public_path__ + "static/media/8.73f1aa24.gif";